/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsServiceDeskItsmFeaturesType from '@jira/spa-apps__project-settings-service-desk-itsm-features/src/ItsmFeatures.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskItsmFeatures: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof ProjectSettingsServiceDeskItsmFeaturesType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-project-settings-service-desk-itsm-features", jiraSpaEntry: "async-project-settings-service-desk-itsm-features" */ '@jira/spa-apps__project-settings-service-desk-itsm-features/src/ProjectSettingsServiceDeskItsmFeatures.tsx'
			),
		),
	);

const AsyncProjectSettingsServiceDeskItsmFeatures = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskItsmFeatures}
		pageId="project-settings-itsm-features"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsServiceDeskItsmFeatures;
